import { Badge } from "./ui/badge";

// @ts-ignore
import Photo1 from "../assets/workPhotos/1.webp";
// @ts-ignore
import Photo2 from "../assets/workPhotos/2.webp";
// @ts-ignore
import Photo3 from "../assets/workPhotos/3.webp";
// @ts-ignore
import Photo4 from "../assets/workPhotos/4.webp";
// @ts-ignore
import Photo5 from "../assets/workPhotos/5.webp";
// @ts-ignore
import Photo6 from "../assets/workPhotos/6.webp";
// @ts-ignore
import Photo7 from "../assets/workPhotos/7.webp";
// @ts-ignore
import Photo8 from "../assets/workPhotos/8.webp";

const projects = [
  {
    photo: Photo1,
    title: "Outdoor Security Lighting",
    location: "Detached Home, Blackpool",
    category: "Lighting",
  },
  {
    photo: Photo2,
    title: "Light Fixture Installation",
    location: "New Build, Lytham St Annes",
    category: "Lighting",
  },
  {
    photo: Photo3,
    title: "Kitchen Electrical Fit-Out",
    location: "Semi-Detached, Poulton-le-Fylde",
    category: "Rewiring",
  },
  {
    photo: Photo4,
    title: "Feature LED Lighting",
    location: "Games Room, Blackpool",
    category: "Lighting",
  },
  {
    photo: Photo5,
    title: "Electric Heater Installation",
    location: "Residential, Cleveleys",
    category: "Installation",
  },
  {
    photo: Photo6,
    title: "Commercial Lighting",
    location: "Workshop, Fleetwood",
    category: "Commercial",
  },
  {
    photo: Photo7,
    title: "Kitchen Rewire",
    location: "Terraced Home, Lytham",
    category: "Rewiring",
  },
  {
    photo: Photo8,
    title: "On Call Across the Fylde Coast",
    location: "24/7 Emergency Response",
    category: "Emergency",
  },
];

export const Gallery = () => {
  return (
    <section id="work" className="scroll-mt-20 bg-background py-20">
      <div className="mx-auto max-w-360 px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wider text-primary uppercase">
            Our Work
          </span>
          <h2 className="mt-2 text-3xl font-bold sm:text-4xl">
            Recent Projects We're Proud Of
          </h2>
          <p className="mt-4 text-muted-foreground">
            A small sample of the electrical work Andrew and the team have completed for happy
            customers across the Fylde Coast.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {projects.map((project) => (
            <div
              key={project.title}
              className="group relative flex aspect-4/3 flex-col justify-end overflow-hidden rounded-2xl border border-white/10"
            >
              <img
                src={project.photo}
                alt={project.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-linear-to-t from-black/75 via-black/20 to-transparent" />
              <div className="relative p-5">
                <Badge variant="secondary" className="mb-2 w-fit">
                  {project.category}
                </Badge>
                <h3 className="text-base font-semibold text-white">{project.title}</h3>
                <p className="text-xs text-neutral-300">{project.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
